// extracted by css-extract-rspack-plugin
export default {"NewProjectPageContainer":"NewProjectPageContainer-act3w8","newProjectPageContainer":"NewProjectPageContainer-act3w8"};